// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { HomeReducer } from './content/dashboards/Summary/slice';
import { TrackingReducer } from './content/management/Tracking/slice';
import { AuthReducer } from './content/auth/slice';
import { ExternalLinkReducer } from './content/pages/IframeViewer/slice';

const trackingPersistConfig = {
  key: 'tracking',
  storage,
};

const homePersistConfig = {
  key: 'home',
  storage,
};

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['isAuthenticated', 'user'] // Only persist auth state and user data
};

const trackingReducer = persistReducer(trackingPersistConfig, TrackingReducer);
const homeReducer = persistReducer(homePersistConfig, HomeReducer);
const authReducer = persistReducer(authPersistConfig, AuthReducer);

export const store = configureStore({
  reducer: {
    Tracking: trackingReducer,
    Home: homeReducer,
    Auth: authReducer,
    ExternalLink: ExternalLinkReducer
  },
});

// Define RootState type
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);